import { select, takeLatest, all, put } from 'redux-saga/effects';
import { privateCall } from './api.saga';
import { posActions } from '../reducers/pos.reducer';
import { modalActions } from '../reducers/modal.reducer';
import { history } from '../store/store';

function* pages({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.pos.pages}${route ? `/${route}` : ''}`);
		const { pages } = yield privateCall({ endpoint, payload: formData, method });

		if (method === 'post') {
			yield put(modalActions.hide());
		} else if (method === 'delete' && !route) {
			history.push(`/${pages[formData?.pageID]?.clientApp}/pages`);
		}

		yield put(posActions.setPage(pages));
	} catch (e) {}
}

export default function* posSaga() {
	yield all([
		yield takeLatest(posActions.pages, pages),
	]);
}
